import { ArrowRight, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BAR_PARFUM_OPEN_EVENT } from "@/lib/bar-parfum-promo";
import barImg from "@/assets/bar-parfum-atelier.jpg";

type Props = { variant?: "row" | "vertical" };

export function BarParfumSection({ variant = "row" }: Props) {
  const openPromo = () => window.dispatchEvent(new Event(BAR_PARFUM_OPEN_EVENT));

  if (variant === "vertical") {
    return (
      <section aria-label="Bar à parfum 2027" className="border border-border bg-card p-6">
        <img src={barImg} alt="Le bar à parfum fleuri de L'Atelier Olfactif" width={440} height={320} loading="lazy" className="h-52 w-full rounded-md object-cover" />
        <p className="mt-5 text-xs font-semibold uppercase text-muted-foreground">Nouveauté · Saison 2027</p>
        <h2 className="mt-2 font-serif-display text-2xl text-foreground">Le bar à parfum</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground">Une animatrice dédiée, un parfum choisi par chaque invité et un flacon personnalisé à emporter. Pour votre mariage ou votre événement.</p>
        <p className="mt-2 text-sm font-semibold text-foreground">Dès 12 € / invité · Minimum 50 invités</p>
        <p className="mt-3 flex items-start gap-2 text-sm leading-relaxed text-foreground"><Gift className="mt-0.5 h-4 w-4 shrink-0" />Étiquettes aux prénoms des mariés offertes aux 5 premiers mariages réservés.</p>
        <Button onClick={openPromo} className="mt-5 h-11 w-full">Je souhaite en profiter<ArrowRight /></Button>
      </section>
    );
  }

  return (
    <section aria-label="Bar à parfum 2027" className="border-y border-border bg-card px-6 py-8 md:py-10">
      <div className="mx-auto grid max-w-6xl items-center gap-6 sm:grid-cols-[180px_1fr] lg:grid-cols-[220px_1fr_auto]">
        <img src={barImg} alt="Le bar à parfum fleuri de L'Atelier Olfactif" width={440} height={320} loading="lazy" className="h-44 w-full rounded-md object-cover sm:h-40" />
        <div>
          <p className="text-xs font-semibold uppercase text-muted-foreground">Nouveauté · Saison 2027</p>
          <h2 className="mt-2 font-serif-display text-3xl text-foreground">Le bar à parfum</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground">Une animatrice dédiée, un parfum choisi par chaque invité et un flacon personnalisé à emporter. Pour votre mariage ou votre événement.</p>
          <p className="mt-2 text-sm font-semibold text-foreground">Dès 12 € / invité · Minimum 50 invités</p>
          <p className="mt-3 flex items-start gap-2 text-sm leading-relaxed text-foreground"><Gift className="mt-0.5 h-4 w-4 shrink-0" />Étiquettes aux prénoms des mariés offertes aux 5 premiers mariages réservés.</p>
        </div>
        <Button onClick={openPromo} className="h-11 sm:col-start-2 lg:col-start-auto">Je souhaite en profiter<ArrowRight /></Button>
      </div>
    </section>
  );
}
